<div class="edit-note-dialog">
  <mat-dialog-content>
    <h3 class="header">Edit Note</h3>
    <mat-form-field class="note-title-field">
      <mat-label>Title (optional)</mat-label>
      <input matInput [formControl]="formControlTitle" type="text" maxlength="200">
    </mat-form-field>
    <custom-angular-editor [formControl]="formControlNote" [height]="250"></custom-angular-editor>
    <div class="actions" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-stroked-button (click)="onCancel()">Cancel</button>
      <button mat-flat-button [disabled]="formGroup.invalid" (click)="onSubmit()">Save</button>
    </div>
  </mat-dialog-content>
</div>
